import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';

function LoginPage() {
  useEffect(() => { document.title = 'PEC - Login'; }, []);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setError('');
      setLoading(true);
      await login(email, password);
      navigate('/'); // Redirige al dashboard después del login exitoso
    } catch (err) {
      console.error("Failed to log in:", err); // Log detallado para depuración
      setError('Failed to log in. Check your email and password.');
    }

    setLoading(false);
  }

  return (
    <div style={{ maxWidth: '400px', margin: 'auto', padding: '20px' }}>
      <h2>Log In</h2>
      {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '10px' }}>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          />
        </div>
        <div style={{ marginBottom: '10px' }}>
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          />
        </div>
        <button disabled={loading} type="submit" style={{ width: '100%', padding: '10px' }}>
          {loading ? 'Logging In...' : 'Log In'}
        </button>
      </form>
      <div style={{ marginTop: '15px', textAlign: 'center' }}>
        Need an account? <Link to="/signup">Sign Up</Link>
      </div>
    </div>
  );
}

export default LoginPage; 